// plugins/chunk-error.client.ts
export default defineNuxtPlugin((nuxtApp) => {
	const router = useRouter();

	const handleChunkError = (err: any) => {
		const errorMsg = String(err?.message || err || "");

		// 1. 精準判定是否為 Chunk 遺失 / 動態載入失敗
		const isChunkError = errorMsg.includes("Failed to fetch dynamically imported module") || errorMsg.includes("Importing a module script failed");

		if (isChunkError) {
			// 2. 加入 sessionStorage 防護機制，防止無限重整
			const hasTriedRescue = sessionStorage.getItem("chunk_rescue_attempted");

			if (!hasTriedRescue) {
				sessionStorage.setItem("chunk_rescue_attempted", "true");

				// 3. 條件符合：強制註銷 Service Worker
				if ("serviceWorker" in navigator) {
					navigator.serviceWorker.getRegistrations().then((registrations) => {
						registrations.forEach((reg) => reg.unregister());
					});
				}

				// 4. 條件符合：強制清除所有 Cache Storage
				if ("caches" in window) {
					caches.keys().then((keys) => {
						keys.forEach((key) => caches.delete(key));
					});
				}

				// 5. 帶亂數時間戳 (?v=TIMESTAMP) 強制跳脫並要求最新 index.html
				setTimeout(() => {
					const cleanUrl = window.location.href.split("?")[0];
					window.location.href = `${cleanUrl}?v=${Date.now()}`;
				}, 100);
			} else {
				// 若帶時間戳重整後依然報錯，代表可能是伺服器連線問題，停止重整並重置標記
				sessionStorage.removeItem("chunk_rescue_attempted");
			}
		}
	};

	// A. 捕捉 Vue Router 轉頁時丟失 Chunk 的錯誤
	router.onError((error) => {
		handleChunkError(error);
	});

	// B. 捕捉頁面初始載入或全域 Unhandled Rejection 錯誤
	if (process.client) {
		window.addEventListener("unhandledrejection", (event) => {
			handleChunkError(event.reason);
		});
	}
});
